// extracted by mini-css-extract-plugin
module.exports = {"boxContain":"styles_boxContain__dvxhT","colorContainer":"styles_colorContainer__3gOdO"};